// Mirror of server conversion types (adapters/meta/conversionMapping.ts).
export const CONVERSION_TYPES = [
  "purchase",
  "initiate_checkout",
  "add_to_cart",
  "lead",
  "complete_registration",
  "messaging_conversation_started",
  "landing_page_view",
  "link_click",
] as const;

// The four ad accounts currently available through our Meta connection —
// used as a fallback list if the live "list ad accounts" call is unavailable.
export const KNOWN_AD_ACCOUNTS = [
  { id: "", name: "LOAD Studios Ads" },
  { id: "", name: "Dodo Holidays ADS" },
  { id: "act_1610853686534061", name: "Aroma D'Zil" },
  { id: "", name: "Protein House Official" },
];

export const SERVICE_OPTIONS = ["ads", "revenue-only", "other"];

// Ad-account spend currencies. Usually auto-detected on sync; settable manually.
export const CURRENCY_OPTIONS = ["USD", "EUR", "MUR"];
